'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["align", "scope", "isHover", "active", "selectable"];
import React from 'react';
import cx from 'classnames';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { SortableTableHeaderCell } from "./SortableTableHeaderCell.mjs";
import { TableHeaderCellElement } from "./TableHeaderCell.mjs";
import { textClass } from "../../styles/index.mjs";
export var TableHeaderCell = function TableHeaderCell(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'start' : _ref$align,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? 'col' : _ref$scope,
    isHover = _ref.isHover,
    active = _ref.active,
    selectable = _ref.selectable,
    props = _objectWithoutProperties(_ref, _excluded);
  if (props.sortable) {
    return /*#__PURE__*/React.createElement(SortableTableHeaderCell, Object.assign({
      align: align,
      scope: scope
    }, props, {
      isHover: isHover,
      className: cx(textClass('bodySmallBold'), props.className),
      "data-encore-id": ENCORE_DATA_IDS.TableHeaderCell
    }));
  }
  return /*#__PURE__*/React.createElement(TableHeaderCellElement, Object.assign({
    $align: align,
    $active: active,
    scope: scope
  }, props, {
    $isHover: isHover,
    $selectable: selectable,
    className: cx(textClass('bodySmallBold'), props.className),
    "data-encore-id": ENCORE_DATA_IDS.TableHeaderCell
  }));
};